import {
  FETCH_EMPLOYER_COMPANY_PROFILE,
  FETCH_EMPLOYER_COUPONS,
  FETCH_EMPLOYER_DRAFT_JOBS,
  FETCH_EMPLOYER_FREE_COMPANY_FEATURED_LOGOS,
  FETCH_EMPLOYER_FREE_JOBS,
  FETCH_EMPLOYER_MODE,
  FETCH_EMPLOYER_PAID_COMPANY_FEATURED_LOGOS,
  FETCH_EMPLOYER_PAID_JOBS,
  FETCH_CUSTOMER_DETAILS,
  SELECT_EMPLOYER_DRAFT_JOB,
  SELECT_EMPLOYER_REPOST_JOB,
  FETCH_OPEN_INVOICES,
} from "./employerConstanst";

export function fetchEmployerPaidJobs(jobs) {
  return {
    type: FETCH_EMPLOYER_PAID_JOBS,
    payload: jobs,
  };
}

export function fetchEmployerFreeJobs(jobs) {
  return {
    type: FETCH_EMPLOYER_FREE_JOBS,
    payload: jobs,
  };
}

export function fetchEmployerDraftJobs(jobs) {
  return {
    type: FETCH_EMPLOYER_DRAFT_JOBS,
    payload: jobs,
  };
}

export function selectedEmployerDraftJob(job) {
  return {
    type: SELECT_EMPLOYER_DRAFT_JOB,
    payload: job,
  };
}

export function selectedEmployerRepostJob(job) {
  return {
    type: SELECT_EMPLOYER_REPOST_JOB,
    payload: job,
  };
}

export function fetchEmployerPaidCompanyFeaturedLogos(logos) {
  return {
    type: FETCH_EMPLOYER_PAID_COMPANY_FEATURED_LOGOS,
    payload: logos,
  };
}

export function fetchEmployerFreeCompanyFeaturedLogos(logos) {
  return {
    type: FETCH_EMPLOYER_FREE_COMPANY_FEATURED_LOGOS,
    payload: logos,
  };
}

export function fetchEmployerCompanyProfile(profile) {
  return {
    type: FETCH_EMPLOYER_COMPANY_PROFILE,
    payload: profile,
  };
}

export function fetchEmployerCoupons(coupons) {
  return {
    type: FETCH_EMPLOYER_COUPONS,
    payload: coupons,
  };
}

export function fetchEmployerMode(mode) {
  return {
    type: FETCH_EMPLOYER_MODE,
    payload: mode,
  };
}

export function fetchCustomerDetails(details) {
  return {
    type: FETCH_CUSTOMER_DETAILS,
    payload: details,
  };
}

export function fetchOpenInvoices(invoices) {
  return {
    type: FETCH_OPEN_INVOICES,
    payload: invoices,
  };
}
